module.exports = __webpack_public_path__ + "img/logo.43777071.png";